// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'

import EmployerAlertListComponent from 'syft-acp-core/entities/EmployerDetail/EmployerAlertList'
import PageTitle, { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'

const EmployerAlertsList = ({ match: { params } }) => {
  const employerName = useEmployerName(Number(params.id))

  return (
    <PageTitle title={['Alerts', recordLabel('Employer', params.id, employerName)]}>
      <div className="page entity-list">
        <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
        <EmployerAlertListComponent employerID={Number(params.id)} />
      </div>
    </PageTitle>
  )
}

EmployerAlertsList.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      // Note: ID gets passed as a string directly from the URL.
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerAlertsList
